<template>
  <div class="Hombox_xr">
    <div class="charts">
      <div id="charts" ref="chartbb" style="width: 503px; height: 103px"></div>
    </div>
  </div>
</template>

<script>
import { SearchKey } from "@/assets/server/api";
const echarts = require("echarts");
export default {
  props: ["pastTradeDataList"],
  data() {
    return {
      value: "",
      Stakednum:[],
      dayall:[],
      
    };
  },
  watch: {
    deep: true,
    pastTradeDataList(val) {
     console.log(val);
     for (var m = 0; m < data.result.pastTradeDataList.length; m++) {
        this.dayalla.push(data.result.pastTradeDataList[m].pastTime);
        this.Transactionsnums.push(data.result.pastTradeDataList[m].txCount);
        this.Stakednums.push(data.result.pastTradeDataList[m].totalStaked);
      }
      
    },
    // dayalla(val){
    //   console.log(val);
    //   this.dayall=val;
    //   console.log(this.dayall);
    // }
    //
  },
  created() {},
  mounted() {
    // this.daojishi();
   // this.initChartsbb();
  },
  methods: {
    initChartsbb() {
      // console.log(this.Stakednums);
      // console.log(this.dayalla);
      this.lineChart = echarts.init(this.$refs.chartbb);
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#242931", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            let str =
              '<span style="color:#898B8D;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#D3F85A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Staked :</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              params[0].value +
              "</span>" +
              "</div>";
            return str;
          },
        },
        grid: {
          top: "1%",
          left: "1%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          show: false,
          data: this.dayalla,
        },
        yAxis: {
          type: "value",
          show: false,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        //data: [820, 932, 901, 934, 1290, 1330, 1320],
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#D3F85A",
                },
                {
                  offset: 0,
                  color: "#D3F85A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
              // 241, 244, 255, 1
            },
            itemStyle: {
              color: "#000",
              borderColor: "#D3F85A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: this.Stakednums,
          },
        ],
      };
     // this.lineChart.clear();
      this.lineChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.Hombox_xr {
  .charts {
    margin-top: 10px;
    width: 503px;
    height: 117px;
    // box-shadow: 8px 9px 6px 0px rgba(211, 248, 90, 0.6);
    opacity: 1;
    // border: 2px solid #d3f85a;
    div {
      width: 503px;
      height: 117px;
    }
  }
}
</style>
